import { render, staticRenderFns } from "./TrainList.vue?vue&type=template&id=e83d61a0&scoped=true"
import script from "./TrainList.vue?vue&type=script&lang=js"
export * from "./TrainList.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/train-list.css?vue&type=style&index=0&id=e83d61a0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83d61a0",
  null
  
)

export default component.exports